module.exports = __webpack_public_path__ + "img/pro_four_6.75c29508.jpg";